import React, { useRef, useState } from 'react';
import { Player, ControlBar, ReplayControl, ForwardControl, VolumeMenuButton } from 'video-react';
import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';
import 'video-react/dist/video-react.css';
import '../styles/VideoPlayer.css';
import { baseUrl } from '../config';



function VideoPlayer({ mediaFile, onTrim }) {
  const videoRef = useRef(null);
  const [startTime, setStartTime] = useState(0);
  const [endTime, setEndTime] = useState(0);
  const [duration, setDuration] = useState(0);

  const handleVideoLoaded = () => {
    const videoDuration = videoRef.current.getState().player.duration;
    setDuration(videoDuration);
    setEndTime(videoDuration);
  };

  const handleTrim = () => {
    onTrim({ start: startTime, end: endTime });
  };

  return (
    <div className="video-player-container">
      <Player ref={videoRef} src={URL.createObjectURL(mediaFile)} onLoadedMetadata={handleVideoLoaded}>
        <ControlBar autoHide={false}>
          <ReplayControl seconds={10} order={1.1} />
          <ForwardControl seconds={10} order={1.2} />
          <VolumeMenuButton vertical />
        </ControlBar>
      </Player>
      <div className="trimming-slider">
        <Slider
          range
          min={0}
          max={duration}
          defaultValue={[0, duration]}
          onChange={([start, end]) => {
            setStartTime(start);
            setEndTime(end);
          }}
        />
        <button onClick={handleTrim}>Trim Video</button>
      </div>
    </div>
  );
}

export default VideoPlayer;

